import { useState, useEffect } from "react";
import { BankItem } from "../../models/bankItem";
import * as bankItemService from "../../service/bankItemService";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";

const BankI = () => {
  const [bank, setBank] = useState<BankItem[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { itemId } = useParams<{ itemId: string }>() ?? { itemId: "" };

  const loadBank = () => {
    const fixedItemId = "9fd2251b-3654-4d77-97fa-04d832996b65";
    bankItemService
      .getAccounts(fixedItemId)
      .then((response) => {
        setBank(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os dados:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadBank();
  }, []);

  const handleCardClick = (accountId: string) => {
    navigate(`/transacao-bank/${accountId}`); // ajusta a rota conforme o seu sistema
  };

  return (
    <>
     <Header/>
    <div className="container-fluid mt-5 pt-5">
      <h2 className="mb-4" style={{ color: "white" }}>Contas Bancárias</h2>

      {loading ? (
        <div className="alert alert-info">Carregando dados...</div>
      ) : bank.length === 0 ? (
        <div className="alert alert-warning">Nenhuma conta encontrada.</div>
      ) : (
        <div className="row">
          {bank.map((item, index) => (
            <div className="col-md-6 mb-4" key={index}>
              <div className="card">
                <div className="card-header">
                  <strong>{item.name}</strong>
                </div>
                <div
                  className="card-body"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCardClick(item.id)}
                >
                <p><strong>ID:</strong> {item.id}</p>
<p><strong>Tipo:</strong> {item.type}</p>
<p><strong>Subtipo:</strong> {item.subtype}</p>
<p><strong>Nome:</strong> {item.name}</p>
{item.marketingName && (
  <p><strong>Nome de Marketing:</strong> {item.marketingName}</p>
)}
<p><strong>CPF/CNPJ:</strong> {item.taxNumber}</p>
<p><strong>Proprietário:</strong> {item.owner}</p>
<p><strong>Número da Conta:</strong> {item.number}</p>
<p><strong>Saldo:</strong> R$ {item.balance.toFixed(2)}</p>
<p><strong>Moeda:</strong> {item.currencyCode}</p>

{item.creditData && (
  <div>
    <strong>Dados de Crédito:</strong>
    <pre>{JSON.stringify(item.creditData, null, 2)}</pre>
  </div>
)}

{item.bankData && (
  <div>
    <strong>Dados Bancários:</strong>
    <p><strong>Número de Transferência:</strong> {item.bankData.transferNumber}</p>
    <p><strong>Saldo de Encerramento:</strong> R$ {item.bankData.closingBalance.toFixed(2)}</p>
    <p><strong>Saldo Investido Automaticamente:</strong> R$ {item.bankData.automaticallyInvestedBalance.toFixed(2)}</p>
  </div>
)}

                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </>
  );
};

export default BankI;
